import { ActionReducerMap, createReducer, on } from '@ngrx/store';

import { betslipRootReducer } from '../base/store/reducer';
import DigitalSettingsActions from '../modules/settings/digital-actions';
import { IBetslipDigitalState, defaultDigitalState } from './state';

export const digitalReducer = createReducer(
    defaultDigitalState,
    on(DigitalSettingsActions.openSettings, (state, action) => {
        return {
            ...state,
            isSettingsOpened: true,
        };
    }),
    on(DigitalSettingsActions.closeSettings, (state, action) => {
        return {
            ...state,
            isSettingsOpened: false,
        };
    }),
);

export const digitalRootReducer: ActionReducerMap<IBetslipDigitalState> = {
    ...betslipRootReducer,
    digital: digitalReducer,
};
